import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import EndingMeetingDialog from './EndingMeetingDialog'
import MeetingControlBar from './MeetingControlBar'
import VideoContainer from './VideoContainer'
import ChatContiner from './ChatContiner'
// import { history } from "../../../index"
import { useDispatch, useSelector } from "react-redux"
import MeetingScreenshots from './MeetingScreenshots'
import moment from "moment"
import Snackbar from '@material-ui/core/Snackbar';
import { Offline, Online } from "react-detect-offline";
import NewControlBar from './NewDesign/NewControlBar'
import Whiteboard from './whiteboard/Whiteboard'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'


const MeetingBody = props => {

    const navigate = useNavigate()

    const [MeetingEndDialogOpen, setMeetingEndDialogOpen] = useState(false)
    //use this to detect share screen
    const [AmISharingScreen, setAmISharingScreen] = useState(false)
    const [Height, setHeight] = useState(0)
    const [IsDrawing, setIsDrawing] = useState(false)
    const [ControlBarOpen, setControlBarOpen] = useState(false)
    const [ScreenShotDialog, setScreenShotDialog] = useState(true)
    const [UseLess, setUseLess] = useState(0)
    const [IsToastDisplayed, setIsToastDisplayed] = useState(false)
    const [IsWhiteBoardOpen, setIsWhiteBoardOpen] = useState(false)

    const isHost = useSelector(({ meeting }) => meeting.IsHost)
    const VerifyData = useSelector(({ auth }) => auth.VerifyData)
    const SOAP = useSelector(({ meeting }) => meeting.SOAP)

    const ScreenShotOpen = useSelector(({ meeting }) => meeting.ScreenShotOpen)
    const IsMeeting = useSelector(({ meeting }) => meeting.MeetingOn)
    const ShowEnd = useSelector(({ meeting }) => meeting.ShowEnd)
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const ScreenShareOn = useSelector(({ meeting }) => meeting.ScreenShareOn);
    // render offline message logic
    const [shouldRenderOffline, setShouldRenderOffline] = useState(false);
  
    useEffect(() => {
      let offlineTimeout;
  
      const handleOffline = () => {
        offlineTimeout = setTimeout(() => {
          setShouldRenderOffline(true);
        }, 3000); // 3 seconds
      };
  
      const handleOnline = () => {
        clearTimeout(offlineTimeout);
        setShouldRenderOffline(false);
      };
  
      window.addEventListener('offline', handleOffline);
      window.addEventListener('online', handleOnline);
  
      return () => {
        window.removeEventListener('offline', handleOffline);
        window.removeEventListener('online', handleOnline);
        clearTimeout(offlineTimeout);
      };
    }, []);
    // render offline login ends here
    useEffect(() => {
        props.setIsWhiteBoardOpenForNavBar(IsWhiteBoardOpen)
    }, [IsWhiteBoardOpen])
    useEffect(() => {
        props.setMeetingEndDialogOpenForNavbar(MeetingEndDialogOpen)
    }, [MeetingEndDialogOpen])

    useEffect(() => {
        if (ScreenShareOn && IsWhiteBoardOpen) {
            toast.info("A patient is sharing screen, Please close the whiteboard to view it!", {
                autoClose: 7000
            })
        }
    }, [ScreenShareOn])
    useEffect(() => {
        if (IsWhiteBoardOpen) {
            // props.CloseChatBox(props.CloseChatBox)
            if (!isHost) return
            console.log("Signal Sent")
            meetingSession?.audioVideo.realtimeSendDataMessage("WHITE_BOARD_ON", JSON.stringify({
                WHITE_BOARD_ON: true
            }), 100000)
        }
    }, [IsWhiteBoardOpen])



    useEffect(() => {
        if (isHost) return
        meetingSession?.audioVideo.realtimeSubscribeToReceiveDataMessage("WHITE_BOARD_ON", async (dataMessage) => {
            console.log("Signal Recieved")
            props.CloseChatBox(false)
            props.CloseChatBoxHARD()
            setTimeout(() => {
                setIsWhiteBoardOpen(prev => true)
            }, 500);
        })
    }, [meetingSession])

    useEffect(() => {
        if (!IsWhiteBoardOpen && isHost) {
            meetingSession?.audioVideo.realtimeSendDataMessage("WHITE_BOARD_OFF", JSON.stringify({
                WHITE_BOARD_OFF: true
            }), 100000)
        }
    }, [IsWhiteBoardOpen])

    useEffect(() => {
        meetingSession?.audioVideo.realtimeSubscribeToReceiveDataMessage("WHITE_BOARD_OFF", async (dataMessage) => {
            setIsWhiteBoardOpen(prev => false)
        })
    }, [meetingSession])

    useEffect(() => {
        if (ShowEnd) {
            setMeetingEndDialogOpen(true)
            setIsWhiteBoardOpen(false)
        }
    }, [ShowEnd])

    // useEffect(() => {
    //     document.addEventListener("mousedown", () => {
    //         setIsDrawing((precx) => true)
    //     })
    //     document.addEventListener("mouseup", () => {
    //         setIsDrawing((precx) => false)
    //     })

    //     return ()=>{
    //         document.removeEventListener("mousedown")
    //         document.removeEventListener("mouseup")
    //     }

    // }, [])

    useEffect(() => {

        if (!isHost) return;

        if (VerifyData && SOAP) {
            settingTimer()
        }
    }, [VerifyData])
    useEffect(() => {
        setHeight(window.innerHeight)
        window.addEventListener("resize", () => {
            setHeight(window.innerHeight)
        })
    }, [window.innerHeight])

    function refreshControl(e) {
        if (!IsMeeting) return
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = '';
    }
    function settingTimer() {
        if (UseLess == 1) return
        setUseLess(1)
        const mYInterval = setInterval(() => {
            if (moment().isBefore(moment.unix(VerifyData.timeEnd).subtract(5, "minutes"))) {
            } else {
                setIsToastDisplayed(true)
                clearInterval(mYInterval)
            }
        }, 5000)
    }

    const IsMobTab = window.innerWidth < 760 ? true : false; // true means tab and mob && false means desktop

    return (
        <div style={{ height: Height - 67, width: "100%", background: "#2a2a2a", }}>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={IsToastDisplayed}
                autoHideDuration={5000}
                onClose={() => setIsToastDisplayed(false)}
                message="Your meeting is going to end in 5 minutes."
                key={"top" + "center"}
            />
{shouldRenderOffline &&
            <Offline>
                <div className="OverLayDisconnect" >
                    Internet connection lost, Trying to reconnect....
                </div>
            </Offline>
}
            <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", position: "relative", }}>
                <VideoContainer
                    ChatBoxOpen={props.ChatBoxOpen}
                    CloseChatBox={props.CloseChatBox}
                    openEndMeetingDialog={() => setMeetingEndDialogOpen(true)}
                    MeetingEndDialogOpen={MeetingEndDialogOpen}
                    AmISharingScreen={AmISharingScreen}
                    ControlBarOpen={ControlBarOpen}
                    ChangeControlBarOpen={() => setControlBarOpen(!ControlBarOpen)}
                    stopWhiteboard={() => {
                        setIsWhiteBoardOpen(false)
                    }}
                    IsWhiteBoardOpen={IsWhiteBoardOpen}
                    setControlBarOff={(e) => setIsDrawing(true)}
                    setControlBarOn={(e) => setIsDrawing(false)}
                />
                {
                    !MeetingEndDialogOpen && !ScreenShotOpen ? (

                        <>
                            {
                                IsWhiteBoardOpen && IsDrawing ? null : (
                                    <NewControlBar
                                        RomStage={props.RomStage}
                                        ChatSectionType={props.ChatSectionType}
                                        AmISharingScreen={AmISharingScreen}
                                        ChatBoxOpen={props.ChatBoxOpen}
                                        CloseChatBox={(e) => props.CloseChatBox(e)}
                                        CloseChatBoxHARD={props.CloseChatBoxHARD}
                                        openEndMeetingDialog={() => setMeetingEndDialogOpen(true)}
                                        setAmISharingScreen={(e) => setAmISharingScreen(e)}
                                        ControlBarOpen={ControlBarOpen}
                                        ChangeControlBarOpen={() => setControlBarOpen(!ControlBarOpen)}
                                        initWhiteboard={() => setIsWhiteBoardOpen(true)}
                                        IsWhiteBoardOpen={IsWhiteBoardOpen}
                                    />
                                )
                            }
                        </>
                    ) : null
                }
            </div>
            {/* {
                IsWhiteBoardOpen ? (
                    <Whiteboard
                        stopWhiteboard={() => {
                            setIsWhiteBoardOpen(false)
                        }}
                        open={IsWhiteBoardOpen}
                        ChatBoxOpen={props.ChatBoxOpen}
                    />
                ) : null
            } */}
            {
                MeetingEndDialogOpen ? (
                    <EndingMeetingDialog
                        isOpen={MeetingEndDialogOpen}
                        close={() => {
                            setMeetingEndDialogOpen(false)

                            if (isHost) {
                                const query2 = new URLSearchParams(location.search)

                                if (query2.has("videosessionid")) {
                                    if (VerifyData.clinicWebsite) {
                                        // window.location.href = "https://www.bluejayhealth.com"
                                        if (VerifyData.clinicWebsite.substring(0, 7) == 'http://' || VerifyData.clinicWebsite.substring(0, 8) == 'https://') {
                                            window.location.href = VerifyData.clinicWebsite
                                        } else {
                                            window.location.href = "https://" + VerifyData.clinicWebsite
                                        }
                                    } else {
                                        window.location.href = "https://www.bluejayhealth.com"
                                    }
                                    return
                                }

                                if (isHost) {
                                    // navigate("/room")
                                    window.location.reload()
                                    navigate()
                                }
                                navigate()
                            } else {
                                if (VerifyData.clinicWebsite) {
                                    // window.location.href = "https://www.bluejayhealth.com"
                                    if (VerifyData.clinicWebsite.substring(0, 7) == 'http://' || VerifyData.clinicWebsite.substring(0, 8) == 'https://') {
                                        window.location.href = VerifyData.clinicWebsite
                                    } else {
                                        window.location.href = "https://" + VerifyData.clinicWebsite
                                    }
                                } else {
                                    window.location.href = "https://www.bluejayhealth.com"
                                }
                            }

                        }}
                    />
                ) : null
            }

        </div>
    )
}

MeetingBody.propTypes = {

}

export default MeetingBody
